import { DataSender } from '../loaders'
/**
* BuyTicketsWidget
*/

class BuyTicketsWidget {
    constructor(target, eventId, options) {
        if(!target || !target.length || !eventId) return;
        if(!options) options = {};

        // properties
        this.target = target;
        this.eventId = eventId;

        // layout
        this.heading = this.target.find('h3');
        this.button = this.target.find('a.btn');
        this.editForm = this.target.find('form');
        this.editFormSubmit = this.editForm.find('button');
        this.editButton = this.target.find('a.edit');

        // texts
        this.texts = options.texts;

        // init
        this.initWidget();
    }

    initWidget() {
        var that = this;

        // this.button.bind('click', function() {
        //     if(!$(this).hasClass('disabled')) {
        //         profile.buyTickets(that.eventId);
        //     }

        //     return false;
        // });

        if(this.editForm.length) {
            this.descriptionField = this.editForm.find('input[name="description"]');
            this.descriptionField.bind('input', function() {
                if($.trim(that.descriptionField.val()).length) {
                    that.heading.text($.trim(that.descriptionField.val()).substr(0, 64));
                }
                else {
                    that.heading.text(that.descriptionField.prop('placeholder'));
                }
            });

            this.buttonLabelField = this.editForm.find('input[name="button"]');
            this.buttonLabelField.bind('input', function() {
                if($.trim(that.buttonLabelField.val()).length) {
                    that.button.text($.trim(that.buttonLabelField.val()).substr(0, 24));

                    if(that.button.text().length > 20) {
                        that.button.addClass('small-text');
                    }
                    else {
                        that.button.removeClass('small-text');
                    }
                }
                else {
                    that.button.text(that.buttonLabelField.prop('placeholder'));
                }
            });

            this.editForm.bind('submit', function() {
                that.save();
                return false;
            });

            this.editButton.bind('click', function() {
                that.toggleForm();
                return false;
            });
        }
    }

    toggleForm() {
        if(!this.editForm.hasClass('shown')) {
            this.heading.addClass('disabled');
            this.button.addClass('disabled');
            this.editForm.addClass('shown');
            this.editFormSubmit.removeClass('success').text(this.editFormSubmit.data('label'));

            this.descriptionField.val(this.descriptionField.prop('placeholder') == this.heading.text() ? '' : this.heading.text()).focus();
            this.buttonLabelField.val(this.buttonLabelField.prop('placeholder') == this.button.text() ? '' : this.button.text());

            this.revertDescription = this.heading.text();
            this.revertButtonLabel = this.button.text();

            $(document).bind('keyup', { reference: this }, this.cancel);
        }
        else {
            this.heading.removeClass('disabled');
            this.button.removeClass('disabled');
            this.editForm.removeClass('shown');

            if(this.revertDescription) {
                this.heading.html(this.revertDescription);
            }

            if(this.revertButtonLabel) {
                this.button.html(this.revertButtonLabel);
            }

            this.descriptionField.blur();
            this.buttonLabelField.blur();

            $(document).unbind('keyup', this.cancel);
        }
    }

    save() {
        var that = this;

        new DataSender({
            data: {
                id: this.eventId,
                description: $.trim(this.descriptionField.val()),
                button: $.trim(this.buttonLabelField.val())
            },
            url: '/event/tickets/save-texts/',

            success: function(data) {
                if(data.status) {
                    that.editFormSubmit.addClass('success').text(that.texts.saved);

                    that.revertDescription = (data.description.length) ? data.description : that.descriptionField.prop('placeholder');
                    that.revertButtonLabel = (data.button.length) ? data.button : that.buttonLabelField.prop('placeholder');

                    window.setTimeout(function() {
                        that.toggleForm();
                    }, 500);
                }
            },

            error: function() {
                that.toggleForm();
            }
        });
    }

    cancel(e) {
        var that = e.data.reference;

        if(e.keyCode == 27) {
            that.toggleForm();
        }
    }
}

export { BuyTicketsWidget }
